import { IconButton, IconButtonProps } from "@chakra-ui/react";
import { Tooltip } from "../components/Tooltip";
import { useTranslation } from "react-i18next";
import { FiMessageSquare } from "react-icons/fi";
import { useAssistantEntry } from "./useAssistantEntry";

export const AssistantPanelTrigger = (props: Partial<IconButtonProps>) => {
  const { t } = useTranslation();
  const open = useAssistantEntry();

  if (!open) {
    return null;
  }

  return (
    <Tooltip label={t("Assistant")}>
      <IconButton
        aria-label={t("Assistant") ?? "Assistant"}
        icon={<FiMessageSquare />}
        variant="ghost"
        size="md"
        onClick={open}
        {...props}
      />
    </Tooltip>
  );
};
